<template>
    <div v-resize="onResize" class="fill-height" ref="container">
        <v-tabs
            ref="tabs"
            active-class="white"
            background-color="grey lighten-3"
            hide-slider
            show-arrows
        >
            <v-tab :to="{ name: 'invoiceConcepts', params: { setting } }">
                Concepts
            </v-tab>
            <v-tab
                :to="{
                    name: 'invoiceCategories',
                    params: {
                        setting,
                    },
                }"
            >
                Categories
            </v-tab>
            <v-tab
                :to="{
                    name: 'invoiceForeignTrade',
                    params: {
                        setting,
                    },
                }"
            >
                Foreign Trade
            </v-tab>
            <v-tab
                v-if="false"
                :to="{
                    name: 'invoiceTypes',
                    params: {
                        setting,
                    },
                }"
            >
                Types
            </v-tab>
        </v-tabs>
        <v-card :loading="loading" flat>
            <v-card-title ref="title">
                <span>Invoicing</span>
            </v-card-title>

            <v-card-subtitle ref="subtitle" class="my-0">
                <v-divider />
            </v-card-subtitle>

            <v-card-text
                class="overflow-y-auto"
                :style="{ height: `${height}px` }"
            >
                <router-view />
            </v-card-text>
        </v-card>
    </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
    name: 'InvoiceSettings',
    components: {},
    props: {
        setting: Object,
    },
    data() {
        return {
            height: 0,
            loading: false,
            error: null,
            errorMsg: null,
            newSetting: this.setting,
            costSettings: null,
            logSettings: null,
            generalSettings: null,
            commercialSettings: null,
            companyId: JSON.parse(localStorage.getItem('company')),
        }
    },
    updated() {
        this.onResize()
    },
    methods: {
        ...mapMutations(['setErrorItems']),
        onResize() {
            const {
                container: { clientHeight: containerHeight },
                tabs: {
                    $el: { clientHeight: tabsHeight },
                },
                title: { clientHeight: titleHeight },
                subtitle: { clientHeight: subtitleHeight },
            } = this.$refs
            this.height =
                containerHeight - tabsHeight - titleHeight - subtitleHeight
        },
        show() {
            if (this.$vuetify.breakpoint.smAndDown) {
                this.$emit('show')
            }
        },
    },
}
</script>
